import useQueryAPI from "./useQueryAPI";

// Generic hook to fetch and cache reference-data bundles
// e.g. useReferenceData("buyback_subtypes", getBuyBackSubtypesListAxios)
//
// This wraps the lower-level `useQueryAPI` hook so that
// reference lists (which rarely change) can use much longer
// cache + stale times than ordinary API calls.
export function useReferenceData(bundle, getReferenceDataListAxios, options = {}) {
  return useQueryAPI(
    ["referenceData", bundle],
    () => getReferenceDataListAxios(bundle),
    {
      // Reference data is static, so here it is extended to  24h.
      staleTime: 24 * 60 * 60 * 1000,   // 24h
      cacheTime: 24 * 60 * 60 * 1000, // 1day
      select: (rows) => ({
        list: Array.isArray(rows) ? rows : [],
        map: new Map((rows || []).map(r => [r.name, r.value]))
      }),
      ...options
    }
  );
}